<template>
  <div class="filled-progress" :class="selector" @click="onToggle">
    <div class="filled-progress__main">
      <div class="filled-progress__btn" v-if="isFixed">
        <BaseSvg name="ico-arrow-down"/>
      </div>
      <div class="filled-progress__head">
        <h4 class="filled-progress__title">
          {{ $tNewVacancy2('Vacancy Completed on') }}
          <b>{{resultProgress}}%</b>
        </h4>
<!--        <span class="filled-progress__status">-->
<!--          {{ $tNewVacancy2('regular resume') }}-->
<!--        </span>-->
      </div>
      <div class="filled-progress__line-wrap-groups">
        <div class="filled-progress__line-wrap">
          <div class="filled-progress__line"
               :style="{width: completeSectionBasePercent + '%'}"></div>
        </div>
        <div class="filled-progress__line-wrap">
          <div class="filled-progress__line"
               :style="{width: completeSectionRequirementsPercent + '%'}"></div>
        </div>
        <div class="filled-progress__line-wrap">
          <div class="filled-progress__line"
               :style="{width: completeSectionDescriptionPercent + '%'}"></div>
        </div>
      </div>

      <template v-if="isFixed">

      </template>
      <collapse-transition>
        <div class="filled-progress__scale" v-if="!isFixed || isOpen">
          <div class="filled-progress__scale-item">
            <span v-html="$tNewVacancy2('Main information')"></span>
          </div>
          <div class="filled-progress__scale-item">
            <span v-html="$tNewVacancy2('requirement for candidate')"></span>
          </div>
          <div class="filled-progress__scale-item">
            <span v-html="$tNewVacancy2('Description')"></span>
          </div>
        </div>
      </collapse-transition>
    </div>

    <div class="filled-progress__check-list-wrap">
      <!--      <div :class="isOpenCheckList ? '_active' : null"-->
      <!--           class="filled-progress__check-list-pusher"></div>-->
      <collapse-transition>
        <div v-if="isOpenCheckList"
             class="filled-progress__check-list">
          <div class="filled-progress__check-list-content">
            <OverlayScrollbarsComponent class="filled-progress__check-list-content-scroll">
              <div v-for="(item, index) in resultList"
                   :key="index"
                   class="filled-progress__list-group">
                <h4 class="filled-progress__list-title">{{$tNewVacancy(item.title)}}</h4>
                <ul class="filled-progress__list">
                  <li v-for="(value, key) in item.subItems"
                      :key="key"
                      :class="value ? '_done' : null"
                      class="filled-progress__list-item">
                    <BaseSvg name="ico-check"/>
                    <a
                      :href="'#' + index"
                      @click.prevent="$emit('click:list-item', `input-${key}`)"
                    >
                      {{$tNewVacancy2(key)}}
                    </a>
                    <span v-if="isRequiredField(key)" style="color: #fd332b">*</span>
                  </li>
                </ul>
              </div>
            </OverlayScrollbarsComponent>
          </div>
        </div>
      </collapse-transition>
      <button @click.prevent="onToggleCheckList"
              :class="isOpenCheckList ? '_active' : null"
              class="filled-progress__toggle-check-list  base-btn">
        {{ $tNewVacancy2('Hide checklist') }}
        <BaseSvg name="ico-arrow-down"/>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {CollapseTransition} from 'vue2-transitions'
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';
  import getBaseInputsComplete from '../../store/vacancyEdit/common/getInputsComplete';

  export default {
    name: 'FilledProgress',
    components: {
      CollapseTransition,
      OverlayScrollbarsComponent
    },
    props: {
      isFixed: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false,
        isOpenCheckList: false
      }
    },
    computed: {
      ...mapGetters('vacancyEdit', [
        'allInputs',
      ]),

      selector() {
        return {
          '_fixed': this.isFixed,
          '_open': this.isOpen
        }
      },

      //BASE
      completeSectionBaseObject() {
        const state = this.$store.state.vacancyEdit.sectionBase
        const inputs = state.inputs

        const result = getBaseInputsComplete(state, inputs)
        return result
      },
      completeSectionBasePercent() {
        const r = this.completeSectionBaseObject
        return 100 / r.mustFilledCount * r.filledCount
      },

      //REQUIREMENTS
      completeSectionRequirementsObject() {
        const state = this.$store.state.vacancyEdit.sectionRequirements
        const inputs = state.inputs

        const result = getBaseInputsComplete(state, inputs)
        return result
      },
      completeSectionRequirementsPercent() {
        const r = this.completeSectionRequirementsObject
        return 100 / r.mustFilledCount * r.filledCount
      },

      //DESCRIPTION
      completeSectionDescriptionObject() {
        const state = this.$store.state.vacancyEdit.sectionDescription

        const inputs = state.inputs

        const photoAndVideoFilesFilled = !!(state.photoAndVideoFiles && state.photoAndVideoFiles.length)
        const additionalDocumentFilled = !!(state.additionalDocument && state.additionalDocument.length)

        const result = getBaseInputsComplete(state, inputs)

        result.mustFilledCount += 1
        result.items['media'] = photoAndVideoFilesFilled
        if(photoAndVideoFilesFilled) {
          result.filledCount += 1
        }

        result.mustFilledCount += 1
        result.items['files'] = additionalDocumentFilled
        if(additionalDocumentFilled) {
          result.filledCount += 1
        }

        return result
      },
      completeSectionDescriptionPercent() {
        const r = this.completeSectionDescriptionObject
        return 100 / r.mustFilledCount * r.filledCount
      },

      resultList() {
        return [{
          title: this.$tNewVacancy2('Main information'),
          subItems: this.completeSectionBaseObject.items
        }, {
          title: this.$tNewVacancy2('requirement for candidate'),
          subItems: this.completeSectionRequirementsObject.items
        }, {
          title: this.$tNewVacancy2('Description'),
          subItems: this.completeSectionDescriptionObject.items
        }]
      },
      resultProgress() {
        return Math.round( (this.completeSectionBasePercent + this.completeSectionRequirementsPercent + this.completeSectionDescriptionPercent) / 3 )
      }
    },
    methods: {
      onToggle() {
        if (!this.isFixed) return
        this.isOpen = !this.isOpen
      },
      onToggleCheckList() {
        this.isOpenCheckList = !this.isOpenCheckList
      },
      isRequiredField(key) {
        return this.allInputs[key]?.required;
      },
    }
  }
</script>

<style>

</style>
